import React from "react";

const PeriodicRangeFilter = ({ filterRange = [], activeRange, setActiveRange }) => {
  const handleSelectRange = (key) => {
    if (setActiveRange) {
      setActiveRange(key);
    }
  };

  return (
    <div className="sim-fiter-range">
      {filterRange.map((item, index) => {
        return (
          <span
            className={activeRange === item.value ? "sim-range-item active" : "sim-range-item"}
            onClick={() => handleSelectRange(item.value)}
          >
            {item.key === activeRange ? item.display : item.name}
          </span>
        );
      })}
    </div>
  );
};

export default PeriodicRangeFilter;
